import { useContext } from 'react';
import Image from 'next/legacy/image';
import classNames from 'classnames';
import { MembershipExtendedPackage } from 'common/interfaces/api';
import {
  checkIsSubbedIzanaviBefore,
  getIzanaviStatusText,
  isCancelingIzanavi,
  isUnPaidSubIzanavi,
} from 'common/utils/membership';
import { getUserYearStartEvent } from 'common/utils/user';
import CheckBox from 'components/atoms/CheckBox';
import useGlobalStore from 'store/global';
import useStore from 'store/timeline';

import { MembershipPaymentSectionContext } from '..';
import styles from './IzanaviPackageSection.module.scss';

const IzanaviPackageSection = () => {
  const {
    currentPaymentBy,
    choosingIzanaviPackage,
    setChoosingIzanaviPackage,
    izanaviPackage,
  } = useContext(MembershipPaymentSectionContext);
  const currentUser = useStore((state) => state.currentUser);
  const isSubbedIzanaviPackageBefore = checkIsSubbedIzanaviBefore(currentUser);
  const izanaviStatusText = getIzanaviStatusText(currentUser);
  const showIzanaviPRDialog = useGlobalStore(
    (state) => state.showIzanaviPRDialog,
  );
  const discountMembershipEvent = getUserYearStartEvent(currentUser);
  const setShowMembershipPayDialog = useGlobalStore(
    (state) => state.setShowMembershipPayDialog,
  );
  const showingCampaignDiscount =
    !!discountMembershipEvent &&
    izanaviPackage?.discounted_web_amount > 0 &&
    izanaviPackage?.web_amount > izanaviPackage?.discounted_web_amount;

  return (
    <div className={styles.izanaviSection}>
      <div
        className={styles.descriptionImage}
        onClick={() => {
          showIzanaviPRDialog(true);
          setShowMembershipPayDialog(null);
        }}
      >
        <Image
          src="/images/izanavi/about-izanavi.png"
          width={248}
          height={39}
        />
      </div>
      <div
        className={styles.izanaviPackage}
        onClick={() => {
          setChoosingIzanaviPackage(!choosingIzanaviPackage);
        }}
      >
        <div
          className={classNames(styles.package, {
            [styles.currentPackage]: choosingIzanaviPackage,
            [styles.isSubbedBefore]: isSubbedIzanaviPackageBefore,
          })}
        >
          <CheckBox
            name="priceMembershipPackage"
            value="izanavi"
            label="IZANAVI"
            className={styles.checkboxInput}
            checked={choosingIzanaviPackage}
          />
          <span className={styles.name}>1カ月プラン</span>
          <span className={styles.line}></span>
          <div className={styles.price}>
            <span className={styles.number}>
              {showingPrice(izanaviPackage)}
              {currentPaymentBy === 'credit' ? '円' : 'コイン'}/ 1カ月
            </span>
            {showingCampaignDiscount ? (
              <span
                className={classNames(styles.plusStatusFlag, {
                  [styles.isCampaignText]: true,
                })}
              >
                3カ月50%割引キャンペーン
              </span>
            ) : (
              !isSubbedIzanaviPackageBefore && (
                <span className={styles.text}>
                  <span className={styles.big}>2週間</span>
                  <span className={styles.big} style={{ color: '#000' }}>
                    無料体験
                  </span>
                </span>
              )
            )}
            {izanaviStatusText && (
              <span
                className={classNames(styles.plusStatusFlag, {
                  [styles.isRed]:
                    isCancelingIzanavi(currentUser) ||
                    isUnPaidSubIzanavi(currentUser),
                })}
              >
                {izanaviStatusText}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const showingPrice = (pack: MembershipExtendedPackage) => {
  if (
    pack.discounted_web_amount > 0 &&
    pack.web_amount > pack.discounted_web_amount
  ) {
    return (
      <span>
        <del style={{ marginRight: '4px' }}>
          {pack.web_amount?.toLocaleString()}
        </del>
        {pack.discounted_web_amount?.toLocaleString()}
      </span>
    );
  }
  return pack.web_amount?.toLocaleString();
};

export default IzanaviPackageSection;
